<template>
  <div v-if="product && productPrice" class="f-col items-start gap-4">
    <h1 ref="productDetailsTitleRef" class="subtitle-3" data-test-id="product-name">
      {{ product.name }}
    </h1>
    <p v-if="$feature.showShortDescriptionOnPDP && product.shortDescription" class="body-4">
      {{ product.shortDescription }}
    </p>
    <vf-carousel class-container="space-x-2 c-brand-4 -mx-4 scroll-px-4 px-4" class-controls="!hidden">
      <product-eyebrow v-if="product.eyebrow" class="b b-grey-80 rounded-full bg-grey-90 px-2 py-1" />
      <product-badge v-if="product.badge" v-bind="product.badge" class="b b-grey-80 rounded-full bg-grey-90 px-2 py-1" />
      <div id="social-proof-container" />
    </vf-carousel>
    <product-pricing
      class="body-4"
      class-current="subtitle-5"
      :currency="product.currency"
      :price="productPrice"
      :show-discount-percentage="$feature.showDiscountPercentageOnCatalog"
      :show-original-price-for-omnibus="$feature.showOmnibusBadgeOnQuickshopAndPDP"
      show-sale-price-tooltip
    />
    <p v-if="product.promoExclusionsMessage" class="body-5 c-grey-20">
      {{ product.promoExclusionsMessage }}
    </p>
  </div>
</template>

<script lang="ts" setup>
const { product, productPrice } = usePdp()
const productDetailsTitleRef = useState<HTMLElement>('productDetailsTitleRef')
</script>
